import { useEffect, useContext, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Heading from "../components/heading";
import List from "../components/list";
import ListItem from "../components/list-item";
import PrimaryButton from "../components/primary-button";
import Section from "../components/section";
import SpaceBetween from "../components/space-between";
import Post from "../models/post";
import { blogs } from "../utils/constants";
import FirebaseContext from "../utils/firebase-context";
import Modal from "../components/modal";
import TextInput from "../components/text-input";
import {useRecoilValue} from "recoil";
import userState from "../utils/user-state";
import {Loading} from "../views/loading";

export default function BlogScreen() {
	const { handle } = useParams<{ handle: string }>();
	const [showModal, setShowModal] = useState(false);
	const [title, setTitle] = useState("");
	const [loading, setLoading] = useState(false);
	const history = useHistory();
	const user = useRecoilValue(userState);

	const firebase = useContext(FirebaseContext);

	const [posts, setPosts] = useState<Post[]>([]);
	useEffect(() => {
		firebase.getPosts(handle).onSnapshot(snapshot => {
			const ps: Post[] = [];
			snapshot.forEach(doc => {
				ps.push(doc.data() as Post);
			});
			setPosts(ps);
		});
	}, [firebase, handle]);

	function close() {
		setShowModal(false);
	}

	async function createPost() {
		setLoading(true);
		if (title === "") return;
		const id = await firebase.createPost(title, handle, user!.firstName + " " + user!.lastName);
		setLoading(false);
		close();
		history.push(`/blogs/${handle}/${id}`);
	}

	return <>
		<Section>
			<SpaceBetween>
				<Heading>
					{blogs.find(b => b.handle === handle)?.title}
				</Heading>
				<PrimaryButton onClick={() => setShowModal(true)}>
					Neuer Post
				</PrimaryButton>
			</SpaceBetween>
		</Section>
		<div>
			{posts.length > 0 && <List>
				{posts.map(post => <ListItem key={post.id} onClick={() => history.push(`/blogs/${handle}/${post.id}`)}>
					{post.title} <span style={{
					fontSize: "0.8rem",
					fontWeight: 400
				}}>{!post.published && "(Unveröffentlicht)"}</span>
				</ListItem>)}
			</List>}
		</div>
		{showModal && <Modal close={close} title={"Neuen Post erstellen"}>
			<TextInput placeholder="Titel" value={title} onChange={e => setTitle(e.target.value)}/>
			<PrimaryButton onClick={createPost}>
				Artikel erstellen
			</PrimaryButton>
		</Modal>}
		{loading && <Loading />}
	</>
}
